import RET_REU from '../../assets/Image/REU_RET.jpg';

export const REU_RET_2023 = (
    <div>
        <p className="title"><b>2023 SDNI REU-RET</b></p>
        <img className="img-fluid" src={RET_REU} alt="Image" />
        <p>
            <span className="programs-span">
                <b>REU: </b>(Front row left to right) Julia Stoneburner, Lilyane Stessman, Kenndal Wiliams, Marina Kartono, Leah Moylan<br />
                <b>REU: </b>(Back row Left to Right) Rohan Luthra, Jadon Salazar, Jacob Mapa<br />
                <b>RET: </b>(Far right) Ashley Tamura
            </span>
            <br /><br />
            {/* At the end of the program, each REU student made a presentation at the 2019 UC San Diego Summer Research Conference, summarizing their respective research projects and accomplishments to include lessons learned.
            <br /><br />
            SDNI anticipates that all participants will share their unique and exciting hands-on research experience and other components of the program to include presentation skills and the writing of a personal statement with several students at their respective colleges, and by doing so will promote STEM and more specifically nanotechnology education. This type of impact is in line with The California NanoTech 2025 Project general mission.
            <br /><br /> */}
            <b>The participants’ final presentations can be found below.</b>
            <br /><br />
            <a href="https://drive.google.com/drive/folders/1w-oRj8FOBXPvYdaxf4fBhaJI2J31lh22"><button className="programs-button">2023 SDNI REU & RET Presentations</button></a>
            <br /><br /><br /><br /><br />
        </p>
    </div>
)